import Radio from "backbone.radio";
import ModalFormLayout from "../generic/form-layout";
import GenericView from "../generic/view";
import Body from "./form-body";
import Buttons from "../generic/button/collection";
import buttons from "./form-buttons";
import templates from "../../utils/templates";

const globalChannel = Radio.channel("global");
const reportChannel = Radio.channel("report");

class FormBody extends ModalFormLayout {
  events() {
    return {
      submit: "_onSubmit",
      "click button.remove": "_onRemove",
    };
  }

  initialize() {
    this.route = this.model.get("route");
  }

  onBeforeShow() {
    // attach instructions
    this.instructions.show(
      new GenericView({
        template: templates.find("report", "customize_report_instructions"),
        model: this.model,
      })
    );

    // render the columns into the body
    this.body.show(
      new Body({
        collection: this.collection,
      })
    );

    // attach form buttons
    this.buttons.show(
      new Buttons({
        buttons,
        meta: this.options,
      })
    );
  }

  _onSubmit(e) {
    e.preventDefault();

    // grab input fields
    const selectedColumns = _.keys(Backbone.Syphon.serialize(this));

    // make sure at least one column was marked visible
    if (_.isEmpty(selectedColumns)) {
      // do nothing, but display warning message
      globalChannel.trigger("status:show", {
        type: "warning",
        message:
          "You cannot hide all report columns. Please update your selections.",
      });
    } else {
      // get latest params used
      // const history = reportChannel.request("history:find", this.route);
      // const params = (history) ? history.getUrl().getData() : null;

      // notify of selections
      reportChannel.request("reporting-preferences-selected", {
        columns: selectedColumns,
        route: this.route,
        params: null,
      });

      // dismiss the parent modal
      this.triggerMethod("dismiss:modal");
    }
  }

  _onRemove(e) {
    e.preventDefault();

    // notify of removal
    reportChannel.request("reporting-preferences-removed", {
      route: this.route,
    });

    // dismiss the parent modal
    this.triggerMethod("dismiss:modal");
  }
}

export { FormBody as default };
